import { render, staticRenderFns } from "./MyPreReleases.vue?vue&type=template&id=8d654092&scoped=true&"
import script from "./MyPreReleases.vue?vue&type=script&lang=js&"
export * from "./MyPreReleases.vue?vue&type=script&lang=js&"
import style0 from "./MyPreReleases.vue?vue&type=style&index=0&id=8d654092&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d654092",
  null
  
)

export default component.exports